import { jsx } from "react/jsx-runtime";
import React from "react";
import Button from "@ingka/button";
const Actions = ({ baseClass, prefix, actions, hidden }) => /* @__PURE__ */ jsx("div", {
  className: `${baseClass}__actions`,
  // If there are actions to render
  children: Array.isArray(actions) && actions.length ? actions.map(
    (action, index) => /* @__PURE__ */ jsx(
      Button,
      {
        type: "tertiary",
        xsmallIconOnly: true,
        iconOnly: true,
        className: `${baseClass}__action`,
        prefix,
        text: action.text,
        ssrIcon: action.ssrIcon,
        onClick: action.onClick,
        "aria-hidden": hidden,
        disabled: hidden || action.disabled
      },
      index
    )
  ) : null
});
export {
  Actions
};
